import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

// import Styles Lib ======> Dev By OmarEyad - Remak -  ##
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import uk from 'uikit'
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js'
Vue.mixin({
  data: function () {
    return {
      get uk () {
        return uk
      },
    }
  },
});

import Vuesax from 'vuesax'
import 'boxicons'
import 'vuesax/dist/vuesax.css' //Vuesax styles
  Vue.use(Vuesax);

 // Import the component
 import VueSkeletonLoader from 'skeleton-loader-vue';
 // Register the component globally
 Vue.component('vue-skeleton-loader', VueSkeletonLoader);


// phone tel
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
Vue.use(VueTelInput, {
  mode: 'international',
  showSearchBox:true,
  showFlags:false
});
// end tel
// google map
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAoOQA_ac1dbUgyXKxal0q3L9M4CtKjq5s',
    libraries: 'places',
  }
});

// counter Up 
import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)


// SASS STYLE MANUAL FILES
import './scss/main.scss';

// End Styles Lib ======> Dev By OmarEyad - Remak -  ##





// Imports Views & components 
import store from './store/store.js'
import Home from '@/views/Home.vue';
import Projects from '@/views/Projects.vue';
import About from '@/views/About.vue';
import Testimonial from '@/views/Testimonial.vue';
import Contact from '@/views/Contact.vue';
import Gallery from '@/views/Gallery.vue';
import Service from '@/views/Service.vue';
// booking pages
import Booking from '@/views/Booking.vue';
import Done from '@/views/Done.vue';
// login Pages 
import Login from '@/views/Login.vue';
import Verfiy from '@/views/Verfiy.vue';
import CompleteAccount from '@/views/CompleteAccount.vue';
// profile pages
import Profile from '@/views/Profile.vue';
// profile blocks
import userprofile from '@/components/profile/profile_block/user_profile';

// Imports Routes Vue Js
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    document.querySelector('body').scrollIntoView({ behavior: 'instant' });
},
routes: [
  { path: '/', component: Home },
  { path: '/homa_page', component: Home },
  { path: '/home', component: Home, name: "Home" },
  { path: '/works', component: Projects, name: "Projects" },
  { path: '/about_us', component: About},
  { path: '/testimonial', component: Testimonial, name: "Testimonial" },
  { path: '/contact_us', component: Contact, name: "Contact" },
  { path: '/gallery', component: Gallery, name: "Gallery" },
  { path: '/service/:id', component: Service, name: "Service" },
  { path: '/booking', component: Booking, name: "Booking" , 
  beforeEnter: (to, from, next) => {
    if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
      next();
      return;
    }
    else {
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      next({
        name: 'Login'
      });
    }
  }
  
},
  { path: '/done-reservation', component: Done, name: "Done" },
  { path: '/login', component: Login, name: "Login",
  beforeEnter: (to, from, next) => {
   if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
     router.push({
       name: 'Booking',
     });
     return;
   }
   store.commit('auth/SET_TOKEN', null);
   store.commit('auth/SET_USER', null);
   next();
 }
},
 { path: '/verifymobile', component: Verfiy, name: "Verfiy",
 beforeEnter: (to, from, next) => {
   if (localStorage.getItem('token') && store.getters['auth/authenticated'] && store.getters['auth/user'].setted_up == false) {
     next({
       name: 'CompleteAccount'
     });
     return;
   }
   else {
     store.commit('auth/SET_TOKEN', null);
     store.commit('auth/SET_USER', null);
     next();
   }
 }
 },
 { path: '/complete-account', component: CompleteAccount, name: "CompleteAccount" ,
 beforeEnter: (to, from, next) => {
   if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
     if(store.getters['auth/user'].setted_up == false){
       next();
     }else{
       router.push({
         name: 'Booking',
       });
     }
     return;
   }
   else {
     store.commit('auth/SET_TOKEN', null);
     store.commit('auth/SET_USER', null);
     next({
       name: 'Login'
     });
   }
 }
},
{
  path: '/profile/user', component: Profile, name: 'Profile',

  beforeEnter: (to, from, next) => {
    // check in go to pofile has valid token and has user info
    if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
      next();
      return;
    }
    store.commit('auth/SET_TOKEN', null);
    store.commit('auth/SET_USER', null);
    router.push({
      name: 'Login',
    });
    if (store.getters['auth/authenticated']) {
      next();
    } else {
      next({
        name: 'Login'
      });
    }
  },
  children: [
    {
        path: '/profile/user',
        name: 'user',
        component: userprofile
    }
]
},
  
  
]
});
// End Routes Vue Js



// Axios BaseURL ======= Vue JS - Remak #
import axios from 'axios';
axios.defaults.baseURL = "https://serverlada.trondheimbilvask.no";
Vue.config.productionTip = false;
store.dispatch('setting_api').then(()=>{
   const my_setting = store.getters['get_setting'];
  const favicon = document.querySelectorAll("link[rel~='icon']");
  const title = document.querySelector('.title_site');
  const desc = document.querySelector('.desc_site');
  
  title.innerHTML = my_setting.name;
  console.log(desc,'desc')
   desc.innerHTML = my_setting.description;
  favicon.forEach((elem)=>{
    elem.href = my_setting.icon.url;
  })
  store.dispatch('header_api').then(()=>{
    require('@/store/subscribe');
    store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  });
   });
});